//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { ModalFormMixin } from '@/mixins/ModalFormMixin';
export default {
  name: "DayQualityControlModal",
  mixins: [ModalFormMixin],
  data: function data() {
    return {
      title: "日质控设置表单",
      tableName: "om_day_quality_control",
      form_fields: ['siteId', 'monitorProject', 'spanValue', 'zeroConcentration', 'spanConcentration', 'userId', 'reviewedBy', 'tenantId'],
      form_fields_time: ['commitTime', 'reviewedTime'],
      validatorRules: {}
    };
  },
  props: ['pagePath'],
  created: function created() {},
  methods: {}
};